// Typelizer digest f5dc562ee70e8e6a2acf05562184a9e0
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /courses/past_courses */
  pastCourses: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/courses/past_courses', {}, options),
    method: 'get',
  }),

  /** GET /courses/director_courses */
  directorCourses: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/courses/director_courses', {}, options),
    method: 'get',
  }),

  /** GET /courses/statistics */
  statistics: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/courses/statistics', {}, options),
    method: 'get',
  }),

  /** GET /courses/statistics/:id */
  statisticsShow: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/courses/statistics/:id', params, options),
    method: 'get',
  }),

  /** GET /courses/export_excel */
  exportExcel: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/courses/export_excel', {}, options),
    method: 'get',
  }),

  /** GET /courses/export_excel_statistics */
  exportExcelStatistics: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/courses/export_excel_statistics', {}, options),
    method: 'get',
  }),

  /** POST /courses/:id/send_confirmation_emails */
  sendConfirmationEmails: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/courses/:id/send_confirmation_emails', params, options),
    method: 'post',
  }),

  /** GET /courses/:id/export_participants_excel */
  exportParticipantsExcel: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/courses/:id/export_participants_excel', params, options),
    method: 'get',
  }),

  /** GET /courses/:id/close */
  closeCourse: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/courses/:id/close', params, options),
    method: 'get',
  }),

  /** POST /courses/:id/close */
  close: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/courses/:id/close', params, options),
    method: 'post',
  }),

  /** POST /courses/:id/reopen */
  reopen: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/courses/:id/reopen', params, options),
    method: 'post',
  }),

  /** POST /courses/:id/upload_closing_file */
  uploadClosingFile: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/courses/:id/upload_closing_file', params, options),
    method: 'post',
  }),

  /** GET /courses */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/courses', {}, options),
    method: 'get',
  }),

  /** POST /courses */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/courses', {}, options),
    method: 'post',
  }),

  /** GET /courses/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/courses/new', {}, options),
    method: 'get',
  }),

  /** GET /courses/:id/edit */
  edit: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/courses/:id/edit', params, options),
    method: 'get',
  }),

  /** GET /courses/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/courses/:id', params, options),
    method: 'get',
  }),

  /** PATCH /courses/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/courses/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /courses/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/courses/:id', params, options),
    method: 'delete',
  }),
}
